import React from 'react'
import { Wysiwyg } from '/react4xp/shared/wysiwyg/wysiwyg'

export default (props) => <Wysiwyg {...props} />